module.exports = __webpack_public_path__ + "img/965d810f0409e3ebe3d875af761f2265.df288200.png";